import { useContext } from 'react';
import useSelectedFilterSet from '../../../../hooks/useSelectedFilterSet';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { LOCAL_STORAGE_KEYS, STORAGE_TYPES } from 'common/constants/constants';
import SaveFilterSetCTA from './SaveFilterSetCTA';

const storageAccessor = BrowserStorageAccessor()[STORAGE_TYPES.LOCAL];

const useTriggerFilterSetCTA = Context => {
  const { modalHandler } = useContext(Context);
  const selectedFilterSet = useSelectedFilterSet(Context);

  const shouldShowSaveFilterSetCTA = () => {
    const dontShowFilterSetCTA =
      JSON.parse(
        storageAccessor.get(LOCAL_STORAGE_KEYS.DONT_SHOW_FILTER_SET_CTA)
      ) || false;

    return !dontShowFilterSetCTA && !selectedFilterSet;
  };

  const triggerModal = () => {
    modalHandler.openModal({
      content: () => (
        <SaveFilterSetCTA Context={Context} onClose={modalHandler.closeModal} />
      )
    });
  };

  return {
    shouldShowSaveFilterSetCTA,
    triggerModal
  };
};

export default useTriggerFilterSetCTA;
